import { configureStore } from "@reduxjs/toolkit";

import privacyReducer from "./Shared/Routes/privacySlice";
import termsReducer from "./Shared/Routes/termsSlice";
import faqReducer from "./Shared/Routes/faqSlice";
import aboutUsReducer from "./Shared/Components/AboutUs/aboutusSlice";
import settingsReducer from "./Shared/Components/Footer/settingsSlice";
import productsReducer from "./Shared/Components/Products/productsSlice";
import authReducer from "./Shared/Components/Auth/authSlice";
import cartReducer from "./Shared/Components/Cart/cartSlice";
import ordersReducer from "./Shared/Components/Orders/ordersSlice";
import myBooksReducer from "./Shared/Components/MyBooks/myBooksSlice";
import podcastsReducer from "./Shared/Components/Podcasts/podcastsSlice";
import radioReducer from "./Shared/Components/Radio/radioSlice";
import currencyReducer from "./Shared/Components/Currency/currencySlice";
import profileReducer from "./Shared/Components/Account/profileSlice";

const store = configureStore({
  reducer: {
    privacy: privacyReducer,
    terms: termsReducer,
    faq: faqReducer,
    aboutUs: aboutUsReducer,
    settings: settingsReducer,
    products: productsReducer,
    auth: authReducer,
    cart: cartReducer,
    orders: ordersReducer,
    myBooks: myBooksReducer,
    podcasts: podcastsReducer,
    radio: radioReducer,
    currency: currencyReducer,
    profile: profileReducer,
  },
});

export default store;